import React, { useEffect, useRef, useState } from 'react'
import { Container, ContainerCliente } from './style'
import ViewPage from '../../../Components/ViewPage'
import { ItensPerUserLogged } from '../../../services/login/permissaoUsuarioLoado'
import { TitleH1 } from '../../../Components/CustomUi/titleH1'
import { TabelaClientes } from './components/tabela'
import { formatarValor } from '../../../utils'
import dayjs, { Dayjs } from 'dayjs'
import {
  ClienteItensTypes,
  delCliente,
  getCliente,
  postCliente,
  putCliente,
} from '../../../services/Cliente'
import { buscaCidade, tryError } from '../../../services/Afins'
import { Drawer, UploadFile } from 'antd'
import ButtonCustom from '../../../Components/ButtonCustom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFloppyDisk, faXmark } from '@fortawesome/free-solid-svg-icons'
import { NavegacaoDrawer } from '../recomendacao/novoCompatibilidadeAtivo/components/gavetaCadastrar/styled'
import { FormCliente } from '../../../Components/cliente/novo-index'
import { UploadChangeParam } from 'antd/lib/upload'
import { UploadRequestOption } from 'rc-upload/lib/interface'
import base64 from '../../../Components/Base64Geral'
import { v4 as uid } from 'uuid'
import { AxiosResponse } from 'axios'
import { getEquipe, TypesEquipe } from '../../../services/Equipe'
import { destroyAlert, errorAlert, loadingAlert, successAlert } from '../../../utils/alert'
import {
  getRepresentanteLegal,
  postRepresentanteLegal,
  putRepresentanteLegal,
} from '../../../services/RepresentanteLegal'

import { verificarSeAlgoEstaPreenchido, verificarSeHouveAlteracoes } from './meta'
import { ConfirmarFecharGaveta } from '../patrimonioNovo/components/confirmarFecharGaveta'

const NovoCliente: React.FC = () => {
  //PAGE
  const [dataTableRelative, setDataTableRelative] = useState<ClienteItensTypes[]>([])
  const [preserveListClient, setPreserveListClient] = useState<ClienteItensTypes[]>([])
  const [dadosEstatisticas, setDadosEstatisticas] = useState([])
  const [dadosResultado, setDadosResultado] = useState([])
  const [disableTab, setDisableTab] = useState(false)
  const [loadingStatus, setLoadingStatus] = useState(null)
  const [visible, setVisible] = useState(false)
  const [saveCad, setSaveCad] = useState('')
  const [idCliente, setIdCliente] = useState(0)
  const [typeSubmit, setTypeSubmit] = useState({
    type: '',
    submit: false,
    tab: '1',
  })
  const [statusCliente, setStatusCliente] = useState(1)
  const [clienteSelect, setClienteSelect] = useState(0)
  const [loadingSalvar, setLoadingSalvar] = useState(false)
  const [openPopover, setOpenPopover] = useState(false)
  const [timeRenderizar, setTimeRenderizar] = useState(true)
  const [dados_campos_originais, setDados_campos_originais] = useState({})

  //TABELA
  const [buscarTabela, setBuscarTabela] = useState('')
  const [loadingTable, setLoadingTable] = useState(false)
  const [permission, setPermission] = useState<ItensPerUserLogged>()
  const [pagination, setPagination] = useState<number>(15)
  const [page, setPage] = useState<number>(1)
  const [total, setTotal] = useState(null)
  const [update, setUpdate] = useState(0)
  const [confirmar_exclusao, setConfirmar_exclusao] = useState<boolean>(false)
  const [id_item_atual, setId_item_atual] = useState<number>(null)
  const [nome_item_atual, setNome_item_atual] = useState<string>('')
  const [fake_loading, setFake_loading] = useState<boolean>(false)
  const [inativos, setInativos] = useState(false)

  //FORMULARIO
  const uploadLogo = useRef(null)
  const uploadAssinatura = useRef(null)
  const [tab_selecionado_atual, setTab_selecionado_atual] = useState<
    'Dados do cliente' | 'Sociedade/Representantes' | 'Módulos do cliente'
  >('Dados do cliente')
  const [tipo_cliente, setTipo_cliente] = useState<string>('F')
  const [imageUrl, setImageUrl] = useState<any>(null)
  const [loadingImg, setLoadingImg] = useState(false)
  const [fileListImg, setFileListImg] = useState([])
  const [previewVisibleImg, setPreviewVisibleImg] = useState(false)
  const [loadingForm, setLoadingForm] = useState<boolean>(false)

  //DADOS CLIENTES
  const [nome, setNome] = useState<string>('')
  const [razao_social, setRazao_social] = useState<string>('')
  const [dataNascimento, setDataNascimento] = useState<Dayjs | null>(null)
  const [cpf, setCpf] = useState<string>('')
  const [cnpj, setCnpj] = useState<string>('')
  const [rg, setRg] = useState<string>('')
  const [orgaoExpedidor, setOrgaoExpedidor] = useState<string>('')
  const [sexo, setSexo] = useState<string>('')
  const [email, setEmail] = useState<string>('')
  const [escolaridade, setEscolaridade] = useState<string>('')
  const [escolaridadeId, setEscolaridadeId] = useState<number>(null)
  const [celular, setCelular] = useState<string>('')
  const [fone_fixo, setFone_fixo] = useState<string>('')
  const [nacionalidade, setNacionalidade] = useState<string>('')
  const [profissao, setProfissao] = useState<string>('')
  const [profissaoId, setProfissaoId] = useState<number>(null)
  const [estado_civil, setEstado_civil] = useState<string>('')
  const [estado_civilId, setEstado_civilId] = useState<number>(null)
  const [cep, setCep] = useState<string>('')
  const [estado, setEstado] = useState<string>('')
  const [estadoId, setEstadoId] = useState<number>(null)
  const [cidade, setCidade] = useState<string>('')
  const [cidadeId, setCidadeId] = useState<number>(null)
  const [logradouro, setLogradouro] = useState<string>('')
  const [bairro, setBairro] = useState<string>('')
  const [numero, setNumero] = useState<string>('')
  const [complemento, setComplemento] = useState<string>('')
  const [ie, setIe] = useState<string>('')
  const [outros, setOutros] = useState<string>('')
  const [dataCidadeFilter, setDataCidadeFilter] = useState([])
  const [dataCity, setDataCity] = useState([])

  //SOCIEDADE/REPRESENTANTES
  const [nome_usuario, setNome_usuario] = useState<string>('')
  const [nome_usuarioId, setNome_usuarioId] = useState<number>(null)
  const [outros_solicitantes, setOutros_solicitantes] = useState<string>('')
  const [porcentagem, setPorcentagem] = useState<string>('')
  const [observacoes, setObservacoes] = useState<string>('')
  const [representante_legal, setRepresentante_legal] = useState<boolean>(false)
  const [selectedFile, setSelectedFile] = useState([])
  const [previewImage, setPreviewImage] = useState({
    image: null,
    visible: false,
    title: null,
  })
  const [editar, setEditar] = useState<boolean>(false)
  const [codRepresentante, setCodRepresentante] = useState<number>(null)
  const [list_representantes, setList_representantes] = useState([])
  const [loadingRepresentante, setLoadingRepresentante] = useState<boolean>(false)

  function getBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = () => resolve(reader.result)
      reader.onerror = (error) => reject(error)
    })
  }

  const handleChangeCidadeUf = async (cod) => {
    if (cod) {
      const resCity = await buscaCidade('', cod, '')
      setDataCity(resCity)
      setDataCidadeFilter(resCity)
    }
  }

  async function editarCliente() {
    setLoadingForm(true)
    const dataClientes = await getCliente(update, '', '', 'estatisticas', pagination, page)
    let cnpj = ''
    let cpf = ''
    if (String(dataClientes?.data?.itens[0]?.cpf_cnpj)?.length === 18) {
      cnpj = String(dataClientes?.data?.itens[0]?.cpf_cnpj ?? '')
    } else {
      cpf = String(dataClientes?.data?.itens[0]?.cpf_cnpj ?? '')
    }
    const data = {
      nome: dataClientes?.data?.itens[0]?.nome ?? '',
      cpf: cpf,
      cnpj: cnpj,
      rg: dataClientes?.data?.itens[0]?.rg ?? '',
      orgao_expedidor: dataClientes?.data?.itens[0]?.uf_rg ?? '',
      email: dataClientes?.data?.itens[0]?.email ?? '',
      sexo: dataClientes?.data?.itens[0]?.sexo ?? '',
      nacionalidade: dataClientes?.data?.itens[0]?.nacionalidade ?? '',
      escolaridade: dataClientes?.data?.itens[0]?.escolaridade_nome ?? '',
      profissao: dataClientes?.data?.itens[0]?.profissao_nome ?? '',
      estado_civil: dataClientes?.data?.itens[0]?.estado_civil_nome ?? '',
      celular: dataClientes?.data?.itens[0]?.fone ?? '',
      fixo: dataClientes?.data?.itens[0]?.fone2 ?? '',
      cep: dataClientes?.data?.itens[0]?.cep ?? '',
      estado: dataClientes?.data?.itens[0]?.cidade?.uf_nome ?? '',
      cidade: dataClientes?.data?.itens[0]?.cidade_nome ?? '',
      bairro: dataClientes?.data?.itens[0]?.bairro ?? '',
      logradouro: dataClientes?.data?.itens[0]?.endereco ?? '',
      numero: dataClientes?.data?.itens[0]?.endereco_numero ?? '',
      complemento: dataClientes?.data?.itens[0]?.complemento ?? '',
      outros: dataClientes?.data?.itens[0]?.solicitante ?? '',
    }
    setNome(dataClientes?.data?.itens[0]?.nome ?? '')
    setRazao_social(dataClientes?.data?.itens[0]?.razao_social ?? '')
    setIe(dataClientes?.data?.itens[0]?.inscricao_estadual ?? '')
    setTipo_cliente(dataClientes?.data?.itens[0]?.tipo ?? '')
    setDataNascimento(dataClientes?.data?.itens[0]?.nascimento)
    if (String(dataClientes?.data?.itens[0]?.cpf_cnpj)?.length === 18) {
      setCnpj(String(dataClientes?.data?.itens[0]?.cpf_cnpj ?? ''))
    } else {
      setCpf(String(dataClientes?.data?.itens[0]?.cpf_cnpj ?? ''))
    }
    setRg(String(dataClientes?.data?.itens[0]?.rg ?? ''))
    setOrgaoExpedidor(dataClientes?.data?.itens[0]?.uf_rg ?? '')
    setEmail(dataClientes?.data?.itens[0]?.email ?? '')
    setSexo(dataClientes?.data?.itens[0]?.sexo ?? '')
    setNacionalidade(dataClientes?.data?.itens[0]?.nacionalidade ?? '')
    setEscolaridade(dataClientes?.data?.itens[0]?.escolaridade_nome)
    setEscolaridadeId(dataClientes?.data?.itens[0]?.cod_escolaridade)
    setProfissao(dataClientes?.data?.itens[0]?.profissao_nome)
    setProfissaoId(dataClientes?.data?.itens[0]?.cod_profissao)
    setEstado_civil(dataClientes?.data?.itens[0]?.estado_civil_nome)
    setEstado_civilId(dataClientes?.data?.itens[0]?.cod_estado_civil)
    setCelular(dataClientes?.data?.itens[0]?.fone ?? '')
    setFone_fixo(dataClientes?.data?.itens[0]?.fone2 ?? '')
    setCep(dataClientes?.data?.itens[0]?.cep ?? '')
    setEstado(dataClientes?.data?.itens[0]?.cidade?.uf_nome ?? '')
    setEstadoId(dataClientes?.data?.itens[0]?.cidade_cod_uf)
    handleChangeCidadeUf(dataClientes?.data?.itens[0]?.cidade_cod_uf)
    setCidade(dataClientes?.data?.itens[0]?.cidade_nome)
    setCidadeId(dataClientes?.data?.itens[0]?.cidade?.cod)
    setLogradouro(dataClientes?.data?.itens[0]?.endereco ?? '')
    setBairro(dataClientes?.data?.itens[0]?.bairro ?? '')
    setNumero(dataClientes?.data?.itens[0]?.endereco_numero ?? '')
    setComplemento(dataClientes?.data?.itens[0]?.complemento ?? '')
    setOutros(dataClientes?.data?.itens[0]?.solicitante ?? '')
    setDados_campos_originais(data)
    const uuid = uid()

    const logomarca = {
      file: {
        uuid,
        name: '',
        thumbUrl: dataClientes?.data?.itens[0]?.logo,
      },
      fileList: {
        uuid,
        name: '',
        thumbUrl: dataClientes?.data?.itens[0]?.logo,
      },
    }
    setImageUrl(dataClientes?.data?.itens[0]?.logo)
    uploadLogo?.current?.onSuccess('done', logomarca.file)

    setFileListImg(dataClientes?.data?.itens[0]?.logo === '' ? [] : [logomarca.fileList])

    setTimeout(() => {
      setLoadingForm(false)
    }, 500)
  }

  const refresh = async (loading = false, hide = false) => {
    if (loading) {
      setLoadingTable(true)
    }
    const dataClientes = await getCliente('', buscarTabela, '', 'estatisticas', pagination, page)
    const dados = dataClientes.data.itens
    const filter = dados.filter((rec) => rec.status !== 0)
    let clientes_Ativos = dados.filter((item) => item.status == 1)
    const filterAtivo = dados.filter((rec) => rec.status !== 0)
    const filterInativo = dados.filter((rec) => rec.status === 0)
    setTotal(dataClientes?.data?.total)
    const resultadoAtivo = filterAtivo.reduce(
      (soma, item) => {
        //@ts-ignore
        return {
          //@ts-ignore

          area: soma.area + parseFloat(item?.estatisticas?.total_area_ativa),
        }
      },
      {
        area: 0,
      }
    )
    const resultadoInativo = filterInativo.reduce(
      (soma, item) => {
        //@ts-ignore
        return {
          //@ts-ignore

          area: soma.area + parseFloat(item?.estatisticas?.total_area_ativa),
        }
      },
      {
        area: 0,
      }
    )

    const resultadoFinal = [
      {
        totalizado_area_ativo: formatarValor(resultadoAtivo?.area),
        totalizado_area_inativo: formatarValor(resultadoInativo?.area),
      },
    ]

    // setDataCliente(clientes_Ativos)
    setDataTableRelative(hide ? filter : dados)
    setPreserveListClient(hide ? filter : dados)
    gerarTabela(hide ? filterAtivo : dados)
    gerarTabela2(resultadoFinal, filterAtivo.length, filterInativo.length, hide)
    setLoadingTable(false)
    setLoadingStatus(null)
  }

  function gerarTabela(dados) {
    const data = dados?.map((item) => {
      return [
        { text: item?.nome, fontSize: 7, margin: [0, 2, 0, 2], alignment: 'center' },
        {
          text: item?.tipo === 'J' ? item?.razao_social : '',
          fontSize: 7,
          margin: [0, 2, 0, 2],
          alignment: 'center',
        },
        {
          text: dayjs(item?.nascimento).format('DD/MM/YYYY'),
          fontSize: 7,
          margin: [0, 2, 0, 2],
          alignment: 'center',
        },
        {
          text: formatarValor(parseFloat(item?.estatisticas?.total_area_ativa)),
          fontSize: 7,
          margin: [0, 2, 0, 2],
          alignment: 'right',
        },
        {
          text: item?.estatisticas?.total_propriedades_ativas,
          fontSize: 7,
          margin: [0, 2, 0, 2],
          alignment: 'center',
        },
        {
          text: item?.status === 1 ? 'Ativo' : 'Inativo',
          fontSize: 7,
          margin: [0, 2, 0, 2],
          alignment: 'center',
        },
      ]
    })

    const table = [
      {
        table: {
          headerRows: 1,
          widths: ['*', '*', '*', '*', '*', '*'],
          body: [
            [
              { text: 'Nome', style: 'tableHeader', fontSize: 9, alignment: 'center' },
              { text: 'Razão social', style: 'tableHeader', fontSize: 9, alignment: 'center' },
              {
                text: 'Data nascimento / fundação',
                style: 'tableHeader',
                fontSize: 9,
                alignment: 'center',
              },
              { text: 'Área total', style: 'tableHeader', fontSize: 9, alignment: 'center' },
              { text: 'Propriedades', style: 'tableHeader', fontSize: 9, alignment: 'center' },
              { text: 'Status', style: 'tableHeader', fontSize: 9, alignment: 'center' },
            ],
            ...data,
          ],
          dontBreakRows: true,
          keepWithHeaderRows: 1,
        },
        layout: {
          fillColor: function (rowIndex, node, columnIndex) {
            if (rowIndex === 0) {
              return null
            }
            const status = node.table.body[rowIndex][5].text

            return status === 'Inativo' ? '#ececec' : null
          },
        },
      },
    ]

    setDadosEstatisticas(table)
  }

  function gerarTabela2(dados, lengthAti, lengthInat, hide) {
    const data = dados?.map((item) => {
      return [
        { text: lengthAti, fontSize: 7, margin: [0, 2, 0, 2], alignment: 'center' },
        { text: lengthInat, fontSize: 7, margin: [0, 2, 0, 2], alignment: 'center' },
        {
          text: item?.totalizado_area_ativo,
          fontSize: 7,
          margin: [0, 2, 0, 2],
          alignment: 'center',
        },
        {
          text: item?.totalizado_area_inativo,
          fontSize: 7,
          margin: [0, 2, 0, 2],
          alignment: 'center',
        },
      ]
    })

    const dataAtivo = dados?.map((item) => {
      return [
        { text: lengthAti, fontSize: 7, margin: [0, 2, 0, 2], alignment: 'center' },
        {
          text: item?.totalizado_area_ativo,
          fontSize: 7,
          margin: [0, 2, 0, 2],
          alignment: 'center',
        },
      ]
    })

    const table = [
      {
        table: {
          headerRows: 1,
          widths: ['*', '*', '*', '*'],
          body: [
            [
              {
                text: 'Total de clientes ativo',
                style: 'tableHeader',
                fontSize: 9,
                alignment: 'center',
              },
              {
                text: 'Total de clientes inativo',
                style: 'tableHeader',
                fontSize: 9,
                alignment: 'center',
              },
              {
                text: 'Total de área de clientes ativos',
                style: 'tableHeader',
                fontSize: 9,
                alignment: 'center',
              },
              {
                text: 'Total de área de clientes inativos',
                style: 'tableHeader',
                fontSize: 9,
                alignment: 'center',
              },
            ],
            ...data,
          ],
          dontBreakRows: false,
          keepWithHeaderRows: 1,
          margin: [0, 50, 0, 0],
          alignment: 'center',
        },
        layout: {
          fillColor: function (rowIndex, node, columnIndex) {
            return rowIndex % 2 === 0 ? '#fafafa' : null
          },
        },
      },
    ]

    const tableAtivo = [
      {
        table: {
          headerRows: 1,
          widths: ['*', '*'],
          body: [
            [
              {
                text: 'Total de clientes ativo',
                style: 'tableHeader',
                fontSize: 9,
                alignment: 'center',
              },
              {
                text: 'Total de área de clientes ativos',
                style: 'tableHeader',
                fontSize: 9,
                alignment: 'center',
              },
            ],
            ...dataAtivo,
          ],
          dontBreakRows: false,
          keepWithHeaderRows: 1,
          margin: [0, 50, 0, 0],
          alignment: 'center',
        },
        layout: {
          fillColor: function (rowIndex, node, columnIndex) {
            return rowIndex % 2 === 0 ? '#fafafa' : null
          },
        },
      },
    ]
    const tableFiltrada = hide ? tableAtivo : table
    setDadosResultado(tableFiltrada)
  }

  const handleChangeUpload = async (info) => {
    if (info.file.status === 'uploading') {
      setLoadingImg(true)
    }

    const status = info.file.status === 'removed' ? 'removed' : 'done'

    if (status === 'done') {
      // Get this url from response in real world.
      const temp = await base64(info.file.originFileObj)

      setImageUrl(temp)
      setFileListImg(info.fileList)
      setLoadingImg(false)
    } else {
      setLoadingImg(false)
    }
  }

  const onRemoveLogo = () => {
    setFileListImg([])
    setImageUrl(null)
  }

  const dummyRequest = (options) => {
    const { onSuccess } = options
    setTimeout(() => {
      onSuccess('done')
    }, 500)
  }

  const dummyRequestAss = (options) => {
    const { onSuccess } = options
    setTimeout(() => {
      onSuccess('done')
    }, 500)
  }

  const onChangeUpload = ({ fileList: newFileList }) => {
    setSelectedFile(newFileList)
  }

  const handlePreviewImage = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj)
    }
    setPreviewImage({
      image: file.url || file.preview,
      visible: true,
      title: 'Assinatura',
    })
  }

  const onRemoveAssinatura = () => {
    setSelectedFile([])
  }

  const onPreview = async () => {
    setPreviewVisibleImg(true)
  }

  const handleChangeSwitchStatus = async (cod, index, status: number) => {
    loadingAlert({ msg: 'Alterando status...' })
    try {
      setLoadingStatus(index)
      await putCliente(cod, {
        status: status === 1 ? 0 : 1,
      })

      refresh()
    } catch (error) {
      tryError(error)
      setLoadingStatus(null)
    }
    destroyAlert()
  }

  const openGaveta = () => {
    setVisible(true)
  }
  const openGavetaUpdate = (cod) => {
    setVisible(true)
    setUpdate(cod)
  }

  const onclose = () => {
    setVisible(false)
    setUpdate(null)
    setTab_selecionado_atual('Dados do cliente')
    setTipo_cliente('F')
    setNome('')
    setRazao_social('')
    setOpenPopover(false)
    setDataNascimento(null)
    setCnpj('')
    setCpf('')
    setRg('')
    setIe('')
    setOrgaoExpedidor('')
    setEmail('')
    setSexo('')
    setNacionalidade('')
    setEscolaridade('')
    setEscolaridadeId(null)
    setProfissao('')
    setProfissaoId(null)
    setEstado_civil('')
    setEstado_civilId(null)
    setCelular('')
    setFone_fixo('')
    setCep('')
    setEstado('')
    setEstadoId(null)
    setCidade('')
    setCidadeId(null)
    setLogradouro('')
    setBairro('')
    setNumero('')
    setComplemento('')
    setOutros('')
    setList_representantes([])
    onRemoveLogo()
  }

  function adicionarRepresentante() {
    if (nome_usuario !== '' && outros_solicitantes !== '' && porcentagem !== '') {
      setList_representantes([
        ...list_representantes,
        {
          cod: uid(),
          solicitante: outros_solicitantes,
          cod_usuario: nome_usuarioId,
          usuario_nome: nome_usuario,
          participacao: porcentagem,
          representante: representante_legal ? 1 : 0,
          assinatura: selectedFile[0]?.thumbUrl,
          observacao: observacoes,
        },
      ])
    }
    setNome_usuario('')
    setNome_usuarioId(null)
    setOutros_solicitantes('')
    setPorcentagem('')
    setObservacoes('')
    setRepresentante_legal(false)
    onRemoveAssinatura()
    setCodRepresentante(null)
  }

  const handleClickNewCliente = () => {
    openGaveta()
    setDisableTab(true)
    setSaveCad('Salvar')
    setIdCliente(0)
    setTypeSubmit({ type: 'POST', submit: false, tab: '1' })
  }

  const handleClickCliente = (cod, dados) => {
    if (dados?.tipo === 'F') {
      setDisableTab(true)
    } else {
      setDisableTab(false)
    }

    setStatusCliente(dados?.status)

    setClienteSelect(cod)

    openGavetaUpdate(cod)
    setTypeSubmit({ type: 'PUT', submit: false, tab: '1' })
    setSaveCad('Atualizar Cliente')
  }

  function verificarNovoCadastro() {
    let formulario = {
      nome: nome,
      cpf: cpf,
      cnpj: cnpj,
      rg: rg,
      orgao_expedidor: orgaoExpedidor,
      email: email,
      sexo: sexo,
      nacionalidade: nacionalidade,
      escolaridade: escolaridade,
      profissao: profissao,
      estado_civil: estado_civil,
      celular: celular,
      fixo: fone_fixo,
      cep: cep,
      estado: estado,
      cidade: cidade,
      bairro: bairro,
      logradouro: logradouro,
      numero: numero,
      complemento: complemento,
      outros: outros,
    }
    verificarSeAlgoEstaPreenchido(formulario, setOpenPopover, onclose)
  }

  function validarAlteracoes() {
    let campos_formulario = {
      nome: nome,
      cpf: cpf,
      cnpj: cnpj,
      rg: rg,
      orgao_expedidor: orgaoExpedidor,
      email: email,
      sexo: sexo,
      nacionalidade: nacionalidade,
      escolaridade: escolaridade,
      profissao: profissao,
      estado_civil: estado_civil,
      celular: celular,
      fixo: fone_fixo,
      cep: cep,
      estado: estado,
      cidade: cidade,
      bairro: bairro,
      logradouro: logradouro,
      numero: numero,
      complemento: complemento,
      outros: outros,
    }

    verificarSeHouveAlteracoes(dados_campos_originais, campos_formulario, setOpenPopover, onclose)
  }

  const cadastrarCliente = async () => {
    setLoadingSalvar(true)
    if (cpf.length === 15) {
      setTipo_cliente('F')
    }
    let data = {
      nome: nome,
      status: 1,
      tipo: tipo_cliente,
      inscricao_estadual: ie,
      bairro: bairro,
      cep: cep,
      cod_cidade: cidadeId,
      complemento: complemento,
      cpf_cnpj: !cpf ? cnpj : cpf,
      email: email,
      endereco: logradouro,
      endereco_numero: numero,
      escolaridade: escolaridadeId,
      estado_civil: estado_civilId,
      fone: celular,
      fone2: fone_fixo,
      nacionalidade: nacionalidade,
      nascimento: dayjs(dataNascimento).isValid() ? dayjs(dataNascimento).format('DD/MM/YYYY') : null,
      nome_fantasia: nome,
      profissao: profissaoId,
      razao_social: razao_social,
      rg: rg,
      sexo: sexo,
      tipo_cadastro: tipo_cliente,
      uf_rg: orgaoExpedidor,
      solicitante: outros,
      logo: imageUrl,
    }

    try {
      const eUrl = imageUrl === null ? null : imageUrl.split('://', 1)[0]

      if (eUrl === 'https' || imageUrl === null) {
        data.logo = null
      } else {
        data.logo = imageUrl
      }

      if (update <= 0) {
        const res = await postCliente(data)
        if (res.status === 201) {
          successAlert('Cliente cadastrado com sucesso', 5000, 'atualizando')
          refresh(true)
          setLoadingSalvar(false)
          onclose()
        }
      } else {
        const res = await putCliente(update, data)

        if (res.status === 200) {
          successAlert('Cliente atualizado com sucesso', 5000, 'atualizando')
          refresh(true)
          setLoadingSalvar(false)
          onclose()
        }
      }
    } catch (error) {
      destroyAlert('atualizando')

      if (error.response) {
        const { data } = error.response
        if (!data.error[0].field) {
          errorAlert(data.error ?? 'Falha na operação!')
          setLoadingSalvar(false)
        } else {
          data.error.forEach((data) => {
            errorAlert(data?.msg?.[0] ?? 'Falha na operação!')
            setLoadingSalvar(false)
          })
        }
      }
    }
  }

  async function deletarCliente(cod) {
    setFake_loading(true)
    const conta = localStorage.getItem('conta')
    const responseDel = await delCliente(conta, cod)

    if (responseDel.status === 200) {
      successAlert('Cliente excluido!')
      refresh(true)
    }

    setTimeout(() => {
      setFake_loading(false)
    }, 500)
  }

  const listRepresentante = async () => {
    setLoadingRepresentante(true)
    const response = await getRepresentanteLegal('', update)

    const data = response?.data?.itens?.map((item) => {
      return {
        cod: item?.cod,
        solicitante: item?.solicitante,
        cod_usuario: item?.cod_usu,
        usuario_nome: item?.usuario_nome,
        participacao: item?.participacao,
        representante: item?.representante,
        assinatura: item?.assinatura_base64,
        observacao: item?.observacao,
      }
    })
    setList_representantes(data)

    setTimeout(() => {
      setLoadingRepresentante(false)
    }, 800)
  }

  const cadastrarRepresentante = async () => {
    const removerCod = list_representantes.map(({ cod, usuario_nome, ...resto }) => resto)

    const data = {
      representantes: removerCod,
    }

    try {
      if (update > 0) {
        loadingAlert({ msg: 'Salvando...', id: 'save_repre' })
        const response = await postRepresentanteLegal(data, update)

        if (response.status === 201) {
          successAlert('Representante legal cadastrado com sucesso!', 5000, 'save_repre')
          setNome_usuario('')
          setNome_usuarioId(null)
          setOutros_solicitantes('')
          setPorcentagem('')
          setRepresentante_legal(false)
          setObservacoes('')
          onRemoveAssinatura()
          listRepresentante()
        }
      }
    } catch (error) {
      if (error.response) {
        const { data } = error.response
        if (!data.error[0].field) {
          errorAlert(data?.error ?? 'Falha na operação!', 7000, 'save_repre')
        } else {
          data.error.forEach((data) => {
            errorAlert(data?.msg?.[0] ?? 'Falha na operação!', 7000, 'save_repre')
          })
        }
      } else {
        errorAlert('Falha na operação! (sem resposta)', 7000, 'save_repre')
      }
    }
  }

  function editarRepresentante(
    cod,
    cod_usuario,
    participacao,
    representante,
    solicitante,
    observacao
  ) {
    setEditar(true)
    setCodRepresentante(cod)
    setNome_usuarioId(cod_usuario)
    setPorcentagem(participacao)
    setRepresentante_legal(representante === 1 ? true : false)
    setOutros_solicitantes(solicitante)
    setObservacoes(observacao)
  }

  function abaCadastrar() {
    if (tab_selecionado_atual === 'Dados do cliente') {
      cadastrarCliente()
    }

    if (tab_selecionado_atual === 'Sociedade/Representantes') {
      cadastrarRepresentante()
    }
  }

  useEffect(() => {
    refresh(true)
  }, [])

  useEffect(() => {
    if (!timeRenderizar) {
      refresh(true)
    }
  }, [pagination, page])

  useEffect(() => {
    if (buscarTabela.length > 2) {
      setTimeout(() => {
        refresh(true)
      }, 700)
    }
    if (buscarTabela === '') {
      if (!timeRenderizar) {
        refresh(true)
      }
    }
  }, [buscarTabela])

  useEffect(() => {
    if (inativos) {
      refresh(true, true)
    }
    if (!timeRenderizar && !inativos) {
      refresh(true)
    }
  }, [inativos])

  useEffect(() => {
    if (update > 0) {
      editarCliente()
    }
  }, [update])

  useEffect(() => {
    setTimeout(() => {
      setTimeRenderizar(false)
    }, 3000)
  }, [])

  useEffect(() => {
    if (tipo_cliente === 'F') {
      setCnpj('')
      setRazao_social('')
      setIe('')
    }

    if (tipo_cliente === 'J') {
      setCpf('')
      setRg('')
      setOrgaoExpedidor('')
    }
  }, [tipo_cliente])

  return (
    <ContainerCliente>
      <ViewPage
        title='Fornecedores'
        btnClick={null}
        newHide
        rotina={5}
        onPermission={setPermission}
        hiddeTitle
        cardBodyStyle={{ padding: 15 }}
        cardMainStyle={{ height: '87.5vh' }}
      >
        <div style={{ marginBottom: '10px' }}>
          <TitleH1>Clientes</TitleH1>
        </div>
        <TabelaClientes
          loading={loadingTable}
          abrir={openGaveta}
          editar={handleClickCliente}
          list_clientes={dataTableRelative}
          deletar={deletarCliente}
          permissao={permission}
          total={total}
          confirmar_exclusao={confirmar_exclusao}
          setConfirmar_exclusao={setConfirmar_exclusao}
          id_item_atual={id_item_atual}
          setId_item_atual={setId_item_atual}
          nome_item_atual={nome_item_atual}
          setNome_item_atual={setNome_item_atual}
          fake_loading={fake_loading}
          setFake_loading={setFake_loading}
          page={page}
          setPagination={setPagination}
          setPage={setPage}
          buscarTabela={buscarTabela}
          setBuscarTabela={setBuscarTabela}
          inativos={inativos}
          setInativos={setInativos}
          handleChangeSwitchStatus={handleChangeSwitchStatus}
          dadosEstatisticas={dadosEstatisticas}
          dadosResultado={dadosResultado}
        />
        <Drawer
          width={850}
          open={visible}
          onClose={update <= 0 ? () => verificarNovoCadastro() : () => validarAlteracoes()}
          closable={false}
          bodyStyle={{ padding: 0 }}
          headerStyle={{ padding: '10px 10px' }}
          destroyOnClose
          footer={
            <div className='footer'>
              <ButtonCustom
                icon={<FontAwesomeIcon icon={faFloppyDisk} />}
                type='primary'
                onClick={() => abaCadastrar()}
                loading={loadingSalvar}
                disabled={loadingSalvar}
              >
                Salvar
              </ButtonCustom>
            </div>
          }
          title={
            <NavegacaoDrawer>
              <ButtonCustom
                danger
                icon={<FontAwesomeIcon icon={faXmark} />}
                type='tertiary'
                onClick={update <= 0 ? () => verificarNovoCadastro() : () => validarAlteracoes()}
                style={{ marginLeft: -10 }}
              >
                Fechar
              </ButtonCustom>
            </NavegacaoDrawer>
          }
        >
          <ConfirmarFecharGaveta
            title={`Você não salvou o cadastro!`}
            message='Deseja fechar sem salvar? Todas as informações inseridas serão perdidas.'
            openPopover={openPopover}
            setOpenPopover={setOpenPopover}
            onClose={onclose}
          />
          <FormCliente
            tab_selecionado_atual={tab_selecionado_atual}
            setTab_selecionado_atual={setTab_selecionado_atual}
            tipo_cliente={tipo_cliente}
            setTipo_cliente={setTipo_cliente}
            nome={nome}
            setNome={setNome}
            nascimento={dataNascimento}
            setNascimento={setDataNascimento}
            cpf={cpf}
            setCpf={setCpf}
            rg={rg}
            setRg={setRg}
            orgao_expedidor={orgaoExpedidor}
            setOrgao_expedidor={setOrgaoExpedidor}
            sexo={sexo}
            setSexo={setSexo}
            nacionalidade={nacionalidade}
            setNacionalidade={setNacionalidade}
            escolaridade={escolaridade}
            setEscolaridade={setEscolaridade}
            escolaridadeId={escolaridadeId}
            setEscolaridadeId={setEscolaridadeId}
            estado_civil={estado_civil}
            setEstado_civil={setEstado_civil}
            estado_civilId={estado_civilId}
            setEstado_civilId={setEstado_civilId}
            profissao={profissao}
            setProfissao={setProfissao}
            profissaoId={profissaoId}
            setProfissaoId={setProfissaoId}
            celular={celular}
            setCelular={setCelular}
            fone_fixo={fone_fixo}
            setFone_fixo={setFone_fixo}
            email={email}
            setEmail={setEmail}
            estado={estado}
            setEstado={setEstado}
            estadoId={estadoId}
            setEstadoId={setEstadoId}
            cidade={cidade}
            setCidade={setCidade}
            cidadeId={cidadeId}
            setCidadeId={setCidadeId}
            cep={cep}
            setCep={setCep}
            logradouro={logradouro}
            setLogradouro={setLogradouro}
            numero={numero}
            setNumero={setNumero}
            bairro={bairro}
            setBairro={setBairro}
            complemento={complemento}
            setComplemento={setComplemento}
            outros={outros}
            setOutros={setOutros}
            razao_social={razao_social}
            setRazao_social={setRazao_social}
            cnpj={cnpj}
            setCnpj={setCnpj}
            ie={ie}
            setIe={setIe}
            update={update}
            clienteSelect={clienteSelect}
            statusCliente={statusCliente}
            loadingForm={loadingForm}
            uploadLogo={uploadLogo}
            handleChangeUpload={handleChangeUpload}
            dummyRequest={dummyRequest}
            onPreview={onPreview}
            fileListImg={fileListImg}
            onRemoveLogo={onRemoveLogo}
            previewVisibleImg={previewVisibleImg}
            setPreviewVisibleImg={setPreviewVisibleImg}
            imageUrl={imageUrl}
            onChangeUpload={onChangeUpload}
            fileList={selectedFile}
            dummyRequestAss={dummyRequestAss}
            handlePreviewImage={handlePreviewImage}
            onRemoveAssinatura={onRemoveAssinatura}
            uploadAssinatura={uploadAssinatura}
            nome_usuario={nome_usuario}
            setNome_usuario={setNome_usuario}
            nome_usuarioId={nome_usuarioId}
            setNome_usuarioId={setNome_usuarioId}
            outros_solicitantes={outros_solicitantes}
            setOutros_solicitantes={setOutros_solicitantes}
            porcentagem={porcentagem}
            setPorcentagem={setPorcentagem}
            representante_legal={representante_legal}
            setRepresentante_legal={setRepresentante_legal}
            observacoes={observacoes}
            setObservacoes={setObservacoes}
            list_representantes={list_representantes}
            setList_representantes={setList_representantes}
            loading={false}
            addRepresentante={adicionarRepresentante}
            editarRepresentante={editarRepresentante}
            dataCity={dataCity}
            dataCityFilter={dataCidadeFilter}
            setDataCityFilter={setDataCidadeFilter}
            handleChangeCidadeUf={handleChangeCidadeUf}
            editar={editar}
            listRepresentante={listRepresentante}
            loadingRepresentante={loadingRepresentante}
          />
        </Drawer>
      </ViewPage>
    </ContainerCliente>
  )
}

export default NovoCliente
